import { useMemo } from 'react';
import AssetIcon from '../../../../components/AssetIcon';
import {
  formatBalance,
  formatNumber,
} from '../../../../helpers/NumberFormatter';
import { Bot, Subscription, SubscriptionBalance } from '../../types';

import './index.css';

interface Props {
  bot: Bot;
  subscription: Subscription;
  subscriptionBalance: SubscriptionBalance;
}

const BasicInfo: React.FC<Props> = (props: Props) => {
  const { bot, subscription, subscriptionBalance } = props;
  const { baseAsset, runtime, isActive } = bot;

  const isDuringMultiOrder = useMemo(
    () =>
      runtime?.multiOrder ? !!Object.keys(runtime?.multiOrder).length : false,
    [runtime?.multiOrder],
  );

  const hasBaseAsset = useMemo(
    () => isDuringMultiOrder || runtime?.latestOrder === 'BUY',
    [isDuringMultiOrder, runtime?.latestOrder],
  );

  const hasQuoteAsset = useMemo(
    () =>
      isDuringMultiOrder ||
      runtime?.latestOrder === 'SELL' ||
      typeof runtime?.latestOrder === 'undefined',
    [isDuringMultiOrder, runtime?.latestOrder],
  );

  return (
    <div className="basic-info-container">
      <div className="basic-info-asset-icon-container">
        <AssetIcon baseAsset={baseAsset} width={'100%'} height={'100%'} />
        <div className="basic-info-active-container">
          {isActive ? (
            <div className="basic-info-active" />
          ) : (
            <div className="basic-info-inactive" />
          )}
        </div>
      </div>

      {/* <div className="bi-column">
        <h2 className="bi-text">
          <span className="bi-label">Bot Id:</span> {bot.botId}
        </h2>
        <h2 className="bi-text">
          <span className="bi-label">Cluster Id:</span> {bot.clusterId}
        </h2>
      </div> */}
      <div className="bi-column">
        <h3 className="bi-text">
          <span className="bi-label">Base Asset:</span> {bot.baseAsset}
        </h3>
        <h3 className="bi-text">
          <span className="bi-label">Quote Asset:</span> {bot.quoteAsset}
        </h3>
      </div>
      <div className="bi-column bi-more-space">
        <h3 className="bi-text">
          <span className="bi-label">Total Balance:</span>{' '}
          {formatBalance(subscription.totalValue)}
        </h3>
        <h3 className={`bi-text ${!hasQuoteAsset && 'bi-label'}`}>
          <span className="bi-label">Stable Balance:</span>{' '}
          {formatBalance(subscriptionBalance.stable.current)}
        </h3>
        <h3 className={`bi-text ${!hasBaseAsset && 'bi-label'}`}>
          <span className="bi-label">Asset Balance:</span>{' '}
          {formatNumber(
            subscriptionBalance.asset.current,
            bot.complexParams?.maxDecimals ?? 8,
          )}{' '}
          {bot.baseAsset}
        </h3>
      </div>
    </div>
  );
};

export default BasicInfo;
